export function GlassCard({
  children,
  className = "",
  padded = true,
}: {
  children: React.ReactNode;
  className?: string;
  padded?: boolean;
}) {
  return (
    <div
      className={`glass-panel ${padded ? "rounded-3xl p-5 md:p-6" : ""} ${className}`}
    >
      {children}
    </div>
  );
}
